const initialState = {
  payments: [],
  maintainence_tickets: [],
  people: [],
};

const METADATA_REDUCER = (state = initialState, { type }) => {
  switch (type) {
    case "LOGOUT":
      return { ...initialState };
    default:
      return state;
  }
};

export default METADATA_REDUCER;
